import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { faTrash, faUsers, faWarning } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Editor } from 'ngx-editor';
import { ReportService } from 'src/app/services/report.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from 'src/app/services/user.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ReportForest } from 'src/app/models/reportForest.model';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';

@Component({
  selector: 'app-view-select-line-officer',
  templateUrl: './view-select-line-officer.component.html',
  styleUrls: ['./view-select-line-officer.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})


export class ViewSelectLineOfficerComponent implements OnInit, AfterViewInit {

  @Output() loaded = new EventEmitter();
  faUsers = faUsers;
  faTrash = faTrash;
  faWarning = faWarning;
  faCircleXmark = faCircleXmark as IconProp;
  filtered_roles: any[] = [];

  editors: Editor[] = [];

  report = input.required<any>();
  forests: any[] = []
  lastCheckedEmail: any = "";
  roles: any;
  page = input("8");


  displayedColumns: string[] = ["name", "position", "forest"];
  users = new MatTableDataSource<any>();
  selectUserId: number | null = null;

  fireForm = this.formBuilder.group({
    radio: [""],
  });

  constructor(
    public dialog: MatDialog,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    public readonly userService: UserService,
    public readonly dialogService: DialogService,
    public readonly toast: ConfirmationToastComponent,
  ) {
    this.roles = this.userService.getRoleList();
    this.filtered_roles = this.roles?.filter((r: any) => r.type.slice(-2) == "LO");
  }

  ngOnInit(): void {
    this.loadUsers();
    this.forests = this.report().forests.map((forest: ReportForest) => {
      let newForest = forest as any;
      newForest.form = this.formBuilder.group({
        name_search: [""],
        new_or_existing: [forest.line_officer ? "existing" : ""],
        user_select: [""],
        first_name: [""],
        last_name: [""],
        email: [""],
        phone_num: [""],
        lo_position: [""]
      })
      newForest.selectUserForm = this.formBuilder.group({
        user: [forest.line_officer ?? ""],
      })
      newForest.userExists = false;
      newForest.contact = null;
      newForest.users = new MatTableDataSource<any>();
      return newForest;
    })
  }

  ngAfterViewInit(): void {
    this.loaded.emit(8);
  }


  loadUsers() {
    this.userService.getUserList("LO", ["baer_roles.baer_role"]).subscribe(data => {
      let users = data.users
      users.forEach((user: any) => {
        user.baer_roles = user.baer_roles.filter((role: any) => {
          return role.baer_role.type.slice(-2) == "LO"
        })
        user.tooltip = user.baer_roles.map((role: any) => role.baer_role.text).join("\n")
      })
      this.forests.forEach((forest: any) => {
        let LOs = users.filter((user: any) => user.forest_name == forest.forest_name)
        forest.users.data = LOs

        if (forest.selectUserForm.value.user) {
          forest.selectUserForm.patchValue({
            user: LOs.find((user: any) => user.user_id == forest.selectUserForm.value.user.user_id)
          })
        }
      })
      this.users.data = users
      this.dialogService.closeSpinner()
    });
  }
}
